import {CSSProperties} from "react"
import { BASE_ASSET_URL } from "../../state/consts.ts";

export default function HouseReihenEckhaus(props: {
  selected_menu_item: string;
  onEnterElement: (id: string) => void;
  onLeaveElement: (id: string) => void;
  onClickElement: (id: string) => void;
  element_styling_function: (id: string) => CSSProperties;
  icon_styling_function: (id: string) => CSSProperties;
  outline_styling_function: (id: string) => CSSProperties;
}) {
  const enter_element = props.onEnterElement;
  const leave_element = props.onLeaveElement;
  const click_element = props.onClickElement;
  const element_styling_function = props.element_styling_function;
  const icon_styling_function = props.icon_styling_function;
  const outline_styling_function = props.outline_styling_function; 

  return (  
    <>
  {/*BEGIN SVG*/}
    <svg  viewBox="0 0 3000 3000">
  <defs>
    <style>{`
      .reh-cls-4, .reh-cls-5, .reh-cls-6, .reh-cls-7, .reh-cls-8, .reh-cls-9, .reh-cls-10, .reh-cls-11 {
        fill-rule: evenodd;
      }

      .reh-cls-14 {
        isolation: isolate;
      }

      .reh-cls-15 {
        clip-path: url(#clippath-17);
      }

      .reh-cls-16 {
        clip-path: url(#clippath-19);
      }

      .reh-cls-17 {
        clip-path: url(#clippath-11);
      }

      .reh-cls-18 {
        clip-path: url(#clippath-16);
      }

      .reh-cls-19 {
        clip-path: url(#clippath-18);
      }

      .reh-cls-20 {
        clip-path: url(#clippath-10);
      }

      .reh-cls-21 {
        clip-path: url(#clippath-15);
      }

      .reh-cls-22 {
        clip-path: url(#clippath-13);
      }

      .reh-cls-23 {
        clip-path: url(#clippath-14);
      }

      .reh-cls-24 {
        clip-path: url(#clippath-12);
      }

      .reh-cls-25 {
        clip-path: url(#clippath-20);
      }

      .reh-cls-26 {
        clip-path: url(#clippath-21);
      }

      .reh-cls-27 {
        clip-path: url(#clippath-22);
      }

      .reh-cls-28 {
        mix-blend-mode: multiply;
      }

      .reh-cls-29 {
        clip-path: url(#clippath-1);
      }

      .reh-cls-30 {
        clip-path: url(#clippath-3);
      }

      .reh-cls-31 {
        clip-path: url(#clippath-4);
      }

      .reh-cls-32 {
        clip-path: url(#clippath-2);
      }

      .reh-cls-33 {
        clip-path: url(#clippath-7);
      }

      .reh-cls-34 {
        clip-path: url(#clippath-6);
      }

      .reh-cls-35 {
        clip-path: url(#clippath-9);
      }

      .reh-cls-36 {
        clip-path: url(#clippath-8);
      }

      .reh-cls-37 {
        clip-path: url(#clippath-5);
      }

      .reh-cls-42 {
        clip-path: url(#clippath);
      }
    `}</style>
    <clipPath id="clippath">
      <rect className="reh-cls-1" x="392.38" y="54.71" width="1663.86" height="1653.61"></rect>
    </clipPath>
    <clipPath id="clippath-1">
      <rect className="reh-cls-1" x="337.66" y="14.53" width="1808.42" height="751.01"></rect>
    </clipPath>
    <clipPath id="clippath-2">
      <rect className="reh-cls-1" x="932.03" y="137.45" width="787.76" height="467.13"></rect>
    </clipPath>
    <clipPath id="clippath-3">
      <rect className="reh-cls-1" x="1418.05" y="195.39" width="541.54" height="434.55"></rect>
    </clipPath>
    <clipPath id="clippath-4">
      <rect className="reh-cls-1" x="695.91" y="336.02" width="1197.12" height="1168.2"></rect>
    </clipPath>
    <clipPath id="clippath-5">
      <rect className="reh-cls-1" x="695.91" y="336.02" width="1197.12" height="1168.2"></rect>
    </clipPath>
    <clipPath id="clippath-6">
      <rect className="reh-cls-1" x="695.91" y="336.02" width="1197.12" height="1168.2"></rect>
    </clipPath>
    <clipPath id="clippath-7">
      <rect className="reh-cls-1" x="836.94" y="264.77" width="158.96" height="1045.78"></rect>
    </clipPath>
    <clipPath id="clippath-8">
      <rect className="reh-cls-1" x="836.94" y="264.77" width="158.96" height="1045.78"></rect>
    </clipPath>
    <clipPath id="clippath-9">
      <rect className="reh-cls-1" x="813.6" y="1612.27" width="1227.27" height="736.23"></rect>
    </clipPath>
    <clipPath id="clippath-10">
      <rect className="reh-cls-1" x="1571.13" y="1382.08" width="378.26" height="667.29"></rect>
    </clipPath>
    <clipPath id="clippath-11">
      <rect className="reh-cls-1" x="470.81" y="795.64" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-12">
      <rect className="reh-cls-1" x="1191.4" y="23.62" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-13">
      <rect className="reh-cls-1" x="1306.62" y="351.68" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-14">
      <rect className="reh-cls-1" x="1634.64" y="351.52" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-15">
      <rect className="reh-cls-1" x="639.8" y="973.97" width="1103.21" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-16">
      <rect className="reh-cls-1" x="639.8" y="973.97" width="1103.21" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-17">
      <rect className="reh-cls-1" x="850.61" y="310.21" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-18">
      <rect className="reh-cls-1" x="850.61" y="616.82" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-19">
      <rect className="reh-cls-1" x="1354.86" y="1877.34" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-20">
      <rect className="reh-cls-1" x="1354.86" y="1877.34" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-21">
      <rect className="reh-cls-1" x="1354.86" y="1877.34" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-22">
      <rect className="reh-cls-1" x="1817.97" y="1430.6" width="121.62" height="586.33"></rect>
    </clipPath>
  </defs>
  
  <g className="reh-cls-14">
    <g id="Ebene_1">
      <g id="interaktive_flaechen">
        <g>
          <path id="fassade" className="reh-cls-7" d="M771.92,99.19l-372.24,647.43-5.36,763.34,550.33,201.12,48.34-14.43,4.09-448.35,278.86,54.38,677.84-82.62.63,425.6,41.65,10.67,1012.94-254.42-3.39-647.78-1726.76,5.62L771.92,99.19Z" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={element_styling_function("fassade")}></path>
          <path id="dach" className="reh-cls-9" d="M335.21,761.98l65.14-.94-.19-14.41L772.02,100.03l507.06,660.69,1726.66-6.12,1.06-427.92L762.35,2.16l-427.14,759.82Z" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={element_styling_function("dach")}></path>
          <path id="photovoltaik" className="reh-cls-11" d="M935.81,129.4l-11.15,13.56,354.9,440.25,435.09,16.44,7.4-13.94-373.22-401.39-413.02-54.92Z" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={element_styling_function("photovoltaik")}></path>
          <path id="solarthermie" className="reh-cls-5" d="M1414.39,191.9l-4.55,12.22,395.36,416.98,150.95,4.11,9.88-10.92-399.87-402.73-151.77-19.66Z" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={element_styling_function("solarthermie")}></path>
          <path id="fenster" className="reh-cls-6" d="M2191.89,582.4l-168.3-157.41,8.53-18.31,103.76,8.5,170.79,151.61-8.76,17.92-106.02-2.32ZM2509.15,450.97l91.03,7.3,164.06,132.97-5.7,15.12-89.3-3.27-165.71-137.86,5.62-14.26ZM699.75,341.03l118.78-18.29v1175.05l-118.78-31.5V341.03ZM1014.36,768.92l143.37,2.39,1,286.67-147.19-16.12,2.82-272.94ZM1473.12,773.1l423.74-1.63v257.87l-423.74,33.26v-289.5ZM2176.2,771.41l305.28-2.83v228.85l-305.28,20.18v-246.2ZM2685.02,765.8l234.71.11v197.34l-234.71,15.86v-213.31ZM2481.48,1536.3l-305.28,75.21v-402.2l305.28-39.74v366.73ZM2685.02,1144.45l234.71-30.67v308.86l-234.71,58.56v-336.75Z" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={element_styling_function("fenster")}></path>
          <path id="lueftung" className="reh-cls-8" d="M835.97,261.66l83.82-15.87v377.09l53.07,123.43v496.61l40.63,7.59v47.7l-70.11,18.45-62.46-12.85v-498.53l-44.28-109.06-.66-434.56Z" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={element_styling_function("lueftung")}></path>
          <path id="keller" className="reh-cls-4" d="M1993.42,1655.73l-38.34-9.9-.34-32.34-659.57,147.04-303.74-101.51-.09,36.21s-47.27,10.4-47.27,10.56-120.69-44.43-120.69-44.43v450.16l460.47,252.17,753.08-276.84,1.13-440.97-44.64,9.85Z" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={element_styling_function("keller")}></path>
          <path id="heizung" className="reh-cls-10" d="M1922.43,2029.19l-79.06,29.85-110.21-43.25v-180.17l-154.64-58.44v-44.63l168.97-38.75,174.94-40.43v375.82ZM1955.79,1360.08l-1.3,253.17-662.64,148.54-300.56-102.14v-356.56l22.08-5.15-.32-47.7,266.78,53.94,671.36-82.08,4.6,137.98Z" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={element_styling_function("heizung")}></path>
        </g>
      </g>
      <g id="Rahmen">
        <g id="fassade_rahmen" style={outline_styling_function("fassade")}>
          <g className="reh-cls-42">
            <path className="reh-cls-3" d="M946.42,1708.31l-1.82-.66-304.16-111.38-1.27-2.05c-.55-.89-55.12-88.76-69.31-105.46-13.68-16.11-53.58-40.92-82.69-54.66-23.21-10.95-71.34-14.66-87.93-15.16l-6.86-.21.07-6.86,7.58-707.66.92-1.59L768.74,63.65l3.03,1.75-3.03-1.75,5.15-8.94,507.53,640.47v42.24l774.83,3.07-.02,7-3.09,900.05-60.88,9.65-42.4-10.11v-418.57l-671.87,81.62-273.07-49.73-6.34,437.99-52.15,9.93ZM645.12,1590.52h0s301.89,110.55,301.89,110.55l44.64-8.5,6.38-440.55,280.16,51.02,678.66-82.44v420.95s35.67,8.5,35.67,8.5l53.62-8.5,3.07-894.1h0l-774.8-3.07v-46.77L774.81,67.14l-367.8,638.98-7.56,705.83h0c.61.02,61.38,1.99,90.71,15.83,29.77,14.05,70.75,39.63,85.04,56.46,14.49,17.06,69.21,105.16,69.92,106.3Z"></path>
          </g>
        </g>
        <g id="dach_rahmen" style={outline_styling_function("dach")}>
          <g className="reh-cls-29">
            <path className="reh-cls-3" d="M403.35,765.53l-46.29-5.45-19.4-24.25h29.59L770.34,14.52l767.27,109.44,608.46,622.47-871.8,5.58v-44.05L775.02,79.18l-368.21,636-3.46,50.35ZM360.73,753.47l36.14,4.25,3.07-44.65.41-.7L774.11,66.78l507.16,638.74v39.45l848.27-5.43L1534.27,130.56,774.11,22.13h0s-402.76,720.71-402.76,720.71h-19.13l8.5,10.63Z"></path>
          </g>
        </g>
        <g id="photovoltaik_rahmen" style={outline_styling_function("photovoltaik")}>
          <g className="reh-cls-32">
            <path className="reh-cls-3" d="M1703.86,604.58l-425.28-17.26-1.99-2.45-344.56-424.29v-23.13l412.89,49.43,1.75,1.87,373.12,399.91-15.92,15.93ZM1282.02,580.45l419.06,17.01,8.98-8.98h0s-368.5-394.96-368.5-394.96l-402.52-48.19v12.76l342.99,422.36Z"></path>
          </g>
        </g>
        <g id="solarthermie_rahmen" style={outline_styling_function("solarthermie")}>
          <g className="reh-cls-30">
            <path className="reh-cls-3" d="M1942.54,629.93l-139.1-7.89-1.9-1.98-383.48-398.68,2.36-25.99,144.24,18.22,394.94,399.27-17.06,17.06ZM1806.57,615.21l133.23,7.56,9.92-9.92h0l-388.35-392.6-134.64-17.01h0s-3.49-.32-3.49-.32l3.49.32-1.42,15.59,381.26,396.38h0Z"></path>
          </g>
        </g>
        <g id="fenster_rahmen" style={outline_styling_function("fenster")}>
          <g className="reh-cls-31">
            <path className="reh-cls-3" d="M698.7,587.28l4.52-232.41,113.1-18.85v239.98l-117.62,11.28ZM710.1,360.82l-4.25,218.74,103.46-9.92v-225.35l-99.21,16.54h0Z"></path>
            <path className="reh-cls-3" d="M812.01,1023.72l-112.23-9.71.5-233.1h113.24l-.04,7.04-1.46,235.77ZM706.79,1007.59l98.27,8.5,1.42-228.19h-99.21l-.47,219.69Z"></path>
          </g>
          <path className="reh-cls-3" d="M1150.8,1057.66l-144.47-10.99,2.99-261.51h141.48v272.5ZM1013.41,1040.19l130.39,9.92v-257.95h-127.56s-2.83,248.03-2.83,248.03Z"></path>
          <g className="reh-cls-37">
            <path className="reh-cls-3" d="M812.06,1504.22l-116.15-36.56,4.52-230.88,111.63,21.57v245.87ZM703.01,1462.55l102.05,32.13v-230.55s-97.79-18.9-97.79-18.9l-4.25,217.32Z"></path>
          </g>
          <path className="reh-cls-3" d="M1478.38,1065.69v-277.63l164.24-1.55v266.79l-164.24,12.4ZM1485.38,794.99v263.15l150.24-11.34v-253.23l-150.24,1.42Z"></path>
          <g className="reh-cls-34">
            <path className="reh-cls-3" d="M1744.75,1043.27l3-258.09,145.29-.52-1,251.82-147.29,6.79ZM1754.67,792.16l-2.83,243.78h0s133.23-6.14,133.23-6.14l.94-238.11-131.34.47h0Z"></path>
          </g>
        </g>
        <g id="lueftung_rahmen" style={outline_styling_function("lueftung")}>
          <g className="reh-cls-33">
            <path className="reh-cls-3" d="M836.94,336.43l.91-63.62,54.39-8.04h16.52l-2.69,62.8-69.13,8.86ZM844.77,278.85h0s-.71,49.61-.71,49.61l55.28-7.09,2.13-49.61h-9.22s-47.47,7.09-47.47,7.09Z"></path>
          </g>
          <path className="reh-cls-3" d="M948.96,796.36l-70.64-2.65-1.52-61.84,60.28-.83,11,5.5.88,59.82ZM885.16,786.96l56.69,2.13h0s-.71-48.19-.71-48.19l-5.67-2.83-51.49.71,1.18,48.19h0Z"></path>
          <g className="reh-cls-36">
            <path className="reh-cls-3" d="M934.78,1310.55l-58.92-16.6,1.83-58.67,63.25,9.24,4.13,3.72,23-1.31,27.82,7.34-.32,45.45-51.18,3.62-9.62,7.22ZM883.03,1288.7h0l50.31,14.17,8.5-6.38,46.77-3.31.24-33.54h0l-21.5-5.67-24.8,1.42-4.73-4.25-53.38-7.79h0s-1.42,45.35-1.42,45.35Z"></path>
          </g>
        </g>
        <g id="keller_rahmen" style={outline_styling_function("keller")}>
          <g className="reh-cls-35">
            <path className="reh-cls-3" d="M1279.76,2348.5l-126.83-66.84-188.59-99.39-24.11,2.84-1.93-1.03-124.69-66.24.03-4.24,3.38-454.5,123.56,45.21,40.04-9.71,4.74-36.33,303.86,104.18,663.61-150.17,2.59,34.22,33.85,8.36,50.63-8.16.97,449.99-50.52,14.83-18.24-5.61-692.36,242.61ZM965.68,2175.06l.96.51,313.68,165.32,691.65-242.36,18.42,5.67,43.46-12.76-.95-436.54-43.94,7.09-40.16-9.92-2.36-31.18h0s-657.64,148.82-657.64,148.82l-297.64-102.05h0s-4.25,32.6-4.25,32.6l-46.77,11.34-116.22-42.52-3.31,444.57,120.95,64.25,24.09-2.83Z"></path>
          </g>
        </g>
        <g id="heizung_rahmen" style={outline_styling_function("heizung")}>
          <g className="reh-cls-20">
            <path className="reh-cls-3" d="M1856.45,2049.36h-28.22l-78.98-29.66-16.33-8.16v-5.45c-1.58-1.68-3.42-3.78-4.68-5.67-2.25-3.38-2.16-8.66-.74-31.79.48-7.84.98-15.95.98-20.95,0-12.06-.54-111.97-.63-129.26l-42.27-13.65-4.3.72c-1.18.2-14.14,2.39-19.69,3.38-8.08,1.43-16.02-.92-19.69-3.97-2.91-2.42-3.94-6.61-3.13-12.74l-67.39-19.49-.25-45.25,26.74-6.51-.05-.37,26.1-5.71,1.69.48,150.47,42.75c3.67-1.14,11.36-1.48,32.96,1.95,17.66,2.8,28.11,7.79,31.95,15.25.36.7.66,1.42.89,2.14l1.66.31.32-9.75-183.25-50.1.24-12.24,33.65-7.81,1.68.45,200.98,53.54v20.93l-24.49,6.67-.27,6.99,14.8,5.48,1.24,18.56-14.36,4.42,37.24,9.45.3,205.58-47.49,16.18-7.69,3.29ZM1829.5,2042.36h25.51l6.74-2.88,42.87-14.6-.28-195.12-37.98-9.64v-10.21l14.74-4.53-.57-8.5-15.31-5.67.66-17.2,24.28-6.62v-10.21l-195.78-52.16h0s-26.63,6.19-26.63,6.19l-.03,1.34,183.32,50.12-.76,23.43-14.52-2.72-.27-2.6c-.08-.77-.32-1.55-.71-2.32-1.86-3.62-8.03-8.57-26.82-11.54-22.51-3.57-28.58-2.8-30.19-2.03l-1.2.58-152.87-43.43-18.14,3.97.57,4.54,135.84,40.03-4.3,4.17c-1.15,1.12-1.71,2.24-1.71,3.41,0,3.05-.56,13.79-.89,19.93l-.24,4.45-54.15-16.36-.14-2.44c-.09-1.57-.52-2.84-1.28-3.77-.99-1.21-2.5-1.82-4.52-1.82-4.87,0-7.53.68-8.69,1.09l-1.08.38-4.6-1.38-68.03-22.2.19-26.65-14.36,3.5.19,34.49,68.5,19.81-.67,3.18c-1.56,7.41.02,8.98.2,9.13,1.97,1.64,7.78,3.56,13.99,2.46.18-.03,16.48-2.88,19.84-3.38l.19-2.86,54.43,17.58v2.53c.02,1.19.66,118.67.66,131.83,0,5.21-.51,13.43-1,21.38-.81,13.24-1.58,25.74-.42,27.48.96,1.43,2.73,3.51,4.87,5.71l.99,1.02v3.95l12.48,6.24,77.1,28.91ZM1687.17,1780.85l41.14,12.43c.41-7.91.64-13.31.64-15.1,0-1.34.25-2.65.74-3.91l-129.95-38.3-.26-2.09-.12,17.11,63.09,20.59,2.39.72c2.64-.75,5.96-1.13,9.88-1.13s7.63,1.56,9.94,4.39c1.21,1.48,2.06,3.27,2.51,5.29Z"></path>
            <path className="reh-cls-3" d="M1949.39,1576.28l-33.49-8.89c-2.16,1.9-4.98,2.92-8.16,2.92-4.79,0-81.48-16.77-114.23-23.98l-5.54-1.22,1.12-157.68,19.13-5.36,112.5,21.4-.16,1.11c5.26-.44,9.23.14,11.86,1.73,2.16,1.3,3.66,3.32,4.23,5.67,2.01,8.2,1.47,13.7-1.69,17.3-2.13,2.43-5.31,3.6-8.72,3.23-1.79-.2-4.1-.63-6.93-1.28l.5,110.71,24.65,6.02,4.92,28.32ZM1913.36,1559.48l27.26,7.23-2.27-13.04-25.51-6.24-.57-125.23,4.41,1.16c4.49,1.18,8.06,1.93,10.33,2.18,1.15.13,2.06-.17,2.68-.89,1.44-1.64,1.49-5.55.15-11.02-.14-.55-.48-.99-1.06-1.34-.66-.4-3.48-1.6-11.77-.21l-4.72.79.54-3.78-104.32-19.84-12.47,3.5-1.04,146.74c53.17,11.7,108.66,23.61,112.78,23.81,1.83,0,3.21-.63,4.15-1.91l1.41-1.92Z"></path>
          </g>
        </g>
      </g>
      <g id="Icons">
        <g id="fassade-2" data-name="fassade" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={icon_styling_function("fassade")}>
          <g>
            <g className="reh-cls-17">
              <path className="reh-cls-12" d="M531.6,917.26c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <path className="reh-cls-38" d="M554.53,852.18v-22.89h-45.84v22.89h-19.53v29.33h84.88v-29.33h-19.53.02ZM515.43,836.05h32.32v15.81h-32.32v-15.81ZM495.92,874.75v-15.81h32.28v15.81h-32.28ZM567.28,874.75h-32.28v-15.81h32.28v15.81Z"></path>
          </g>
        </g>
        <g id="dach-2" data-name="dach" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={icon_styling_function("dach")}>
          <g className="reh-cls-24">
            <path className="reh-cls-12" d="M1252.22,145.24c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          </g>
          <path className="reh-cls-38" d="M1298.46,103.39l-16.6-41.02h-57.21l.07.18-15.45,37.08,6.24,2.59,12.82-30.75,12.93,31.92h57.21-.01ZM1277.31,69.12l11.13,27.5h-42.64l-11.13-27.5s42.64,0,42.64,0Z"></path>
        </g>
        <g id="photovoltaik-2" data-name="photovoltaik" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={icon_styling_function("photovoltaik")}>
          <g id="icon">
            <g className="reh-cls-22">
              <path className="reh-cls-12" d="M1367.44,473.29c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <polygon className="reh-cls-38" points="1368.3 386.03 1384.04 386.03 1369.35 409.14 1389.67 409.14 1354.04 445.95 1366.36 420.31 1352.73 420.31 1368.3 386.03"></polygon>
          </g>
        </g>
        <g id="solarthermie-2" data-name="solarthermie" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={icon_styling_function("solarthermie")}>
          <g className="reh-cls-23">
            <g>
              <path className="reh-cls-12" d="M1695.46,473.13c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="reh-cls-38" d="M1683.56,401.55c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.74,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.02Z"></path>
              <path className="reh-cls-38" d="M1683.56,421.53c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
              <path className="reh-cls-38" d="M1683.56,441.53c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
            </g>
          </g>
        </g>
        <g id="fenster-2" data-name="fenster" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={icon_styling_function("fenster")}>
          <g className="reh-cls-21">
            <path className="reh-cls-40" d="M700.59,1095.58c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
          </g>
          <path className="reh-cls-38" d="M719.62,1061.61h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM674.8,1068.37h51.58v-67.17h-51.58v67.17h0Z"></path>
          <g className="reh-cls-18">
            <path className="reh-cls-40" d="M1682.19,1095.58c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
          </g>
          <path className="reh-cls-38" d="M1701.22,1061.61h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM1656.39,1068.37h51.58v-67.17h-51.58v67.17Z"></path>
        </g>
        <g id="lueftung-2" data-name="lueftung" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
          <g className="reh-cls-15">
            <g>
              <path className="reh-cls-41" d="M911.43,431.81c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="reh-cls-38" d="M925.24,349.91c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
              <path className="reh-cls-38" d="M899.87,393.5c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
              <path className="reh-cls-38" d="M890.77,359.01c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
              <path className="reh-cls-38" d="M934.36,384.37c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
            </g>
          </g>
          <g id="lueftung-2" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
            <g className="reh-cls-19">
              <g>
                <path className="reh-cls-41" d="M911.43,738.43c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="reh-cls-38" d="M925.24,656.53c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
                <path className="reh-cls-38" d="M899.87,700.12c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
                <path className="reh-cls-38" d="M890.77,665.63c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
                <path className="reh-cls-38" d="M934.36,690.99c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
              </g>
            </g>
          </g>
        </g>
        <g id="keller-2" data-name="keller" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={icon_styling_function("keller")}>
          <g className="reh-cls-16">
            <g>
              <g className="reh-cls-25">
                <path className="reh-cls-12" d="M1415.66,1998.96c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              </g>
              <path className="reh-cls-38" d="M1446.88,1948.1h-62.44v-33.77l30.12-13.76,32.3,13.7v33.83h.02,0ZM1391.19,1941.34h48.93v-22.59l-25.45-10.79-23.47,10.72v22.66h-.01Z"></path>
              <rect className="reh-cls-38" x="1384.43" y="1947.74" width="6.76" height="24.51"></rect>
              <rect className="reh-cls-38" x="1440.12" y="1947.74" width="6.76" height="24.51"></rect>
              <rect className="reh-cls-38" x="1384.8" y="1954.65" width="58.7" height="6.76"></rect>
              <g className="reh-cls-26">
                <g className="reh-cls-28">
                  <g>
                    <path className="reh-cls-13" d="M1428.72,1893.31"></path>
                    <path className="reh-cls-2" d="M1428.72,1893.31"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="heizung" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={element_styling_function("heizung")}>
          <g className="reh-cls-27">
            <g>
              <path className="reh-cls-39" d="M1878.77,2016.95c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              <path className="reh-cls-38" d="M1848.99,1939.14c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1848.99,1983.77c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="reh-cls-38" d="M1871.8,1939.14c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1871.8,1983.77c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="reh-cls-38" d="M1894.62,1939.14c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1894.62,1983.77c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="reh-cls-38" d="M1914.94,1939.14c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1914.94,1953.42c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
              <path className="reh-cls-39" d="M1878.77,1552.22c33.59,0,60.82-27.23,60.82-60.8s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.8,60.82,60.8"></path>
              <path className="reh-cls-38" d="M1848.99,1474.42c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1848.99,1519.05c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="reh-cls-38" d="M1871.8,1474.42c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1871.8,1519.05c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="reh-cls-38" d="M1894.62,1474.42c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1894.62,1519.05c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
              <path className="reh-cls-38" d="M1914.94,1474.42c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1914.94,1488.7c-5.81,0-10.52-4.73-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.73,10.52,10.52-4.71,10.52-10.52,10.52"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
    {/*END SVG*/}
    <div className={"house-img reiheneckhaus-img"} style={{
              backgroundImage: 'url("'+BASE_ASSET_URL+'/reiheneckhaus.jpg")',
        }}></div>
  </>);
}
